export default __webpack_public_path__ + "static/media/wp-lg.fa3be4dc.png";